import { BASE_URL } from 'constants/api';

import { createGetAPI } from '@cuemath/rest-api';

const { useGet: useParentGet } = createGetAPI({
  getURL: parentId => `${BASE_URL}/parents/${parentId}`,
});

export { useParentGet };
